<template>
  <!-- 导航栏 -->

  <div class="allNavWrap">
    <!-- 移动端折叠 -->
    <div v-if="$store.state.screenWidth <= 768" class="mobNavWrap">
      <div class="menuBox" @click="openMenuMaskFun">
        <div class="menuItem"></div>
        <div class="menuItem"></div>
        <div class="menuItem"></div>
      </div>
      <div class="moblogo">
        <a href="/">
          <img
            class="logoImg"
            src="../assets/images/ABUIABAEGAAg0vvikQYo7d2q3QQwwAI4UA.png"
            alt=""
          />
        </a>
      </div>
      <div class="mobMaskBox" v-if="showMask">
        <div class="closeBtn borline" @click="closeMenuMaskFun">
          <div class="btnLine"></div>
          <div class="btnLine"></div>
        </div>
        <div class="mobNavItem" @click="goIndexFun">
          <span>首　页</span>
        </div>
        <div class="mobNavItem" @click="goMyworksFun">
          <span>作　品</span>
        </div>
        <a
          href="https://k74u68pb5x.jobs.feishu.cn/599592"
          target="_blank"
          @click="closeMenuMaskFun"
        >
        <div class="mobNavItem">
          <span>加入我们</span>
        </div>
      </a>

      </div>
    </div>

    <!-- pc端 -->
    <div v-else class="navWrap" :class="{ blackBg: isScroll }">
      <div class="logo">
        <a href="/">
          <img
            class="logoImg"
            src="../assets/images/ABUIABAEGAAg0vvikQYo7d2q3QQwwAI4UA.png"
            alt=""
          />
        </a>
      </div>
      <div class="navBox">
        <div class="navItem" @click="goIndexFun">
          <span>首　页</span>
        </div>
        <div class="navItem" @click="goMyworksFun">
          <span>作　品</span>
        </div>
        <a
          href="https://k74u68pb5x.jobs.feishu.cn/599592"
          target="_blank"
          class="navItem"
        >
          <span>加入我们</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "naviHeader",
  props: {
    isScroll: Boolean,
  },
  data() {
    return {
      showMask:false,
      screenWidth: null,
    };
  },
  mounted(){
    
  },
  watch:{
    
  },
  methods: {
    openMenuMaskFun(){
      this.showMask = true;
    },
    closeMenuMaskFun(){
      this.showMask = false;
    },
    goIndexFun() {
      this.$router.push("/");
      this.closeMenuMaskFun();
    },
    goMyworksFun() {
      // this.$router.push("/chengji");
      this.$router.push("/videoList")
      this.closeMenuMaskFun();
    },
  },
};
</script>

<style scoped>
.mobNavItem{
  border-bottom: 1px solid #f2f2f2;
  font-size: 14px;
  line-height: 50px !important;
  padding-left: 10px;
  color: #666;
}
.btnLine{
  width: 26px;
  height: 1px;
  background-color: #999;
  position: absolute;
  left: 0;
  top: 16px;
}
.btnLine:nth-child(1){
  transform: rotate(45deg);
}
.btnLine:nth-child(2){
  transform: rotate(-45deg);
}
.borline{
border-bottom: 1px solid #f2f2f2;
}
.closeBtn{
  height: 36px;
  position: relative;
  /* background: plum; */
}
.mobMaskBox{
  width: 100%;
  height: 100vh;
  background-color: #fff;
  color: #000;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  padding: 20px 20px;
  animation: mobMaskBox 0.5s;
  animation-fill-mode: forwards;
}
@keyframes mobMaskBox {
  0%{
    top: -300px;
  }
  100%{
    top: 0;
  }
}
.mobNavWrap{
  width: 100vw;
  height: 50px;
  background-color: #000;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.menuBox{
  width: 22px;
  height: 36px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
}
.menuItem{
  width: 22px;
  height: 2px;
  background-color: #fff;
}
.moblogo{
  width: 120px;
}


.blackBg {
  background-color: rgba(0, 0, 0, 1);
}

@media screen and (max-width: 768px) {
}
.allNavWrap{
  width: 100%;
}
.navWrap {
  width: 100%;
  height: 0.65rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  transition: all 0.5s;
}

.logo {
  width: 1.6rem;
  /* margin-left: 6.112469437652812%; */
  margin-left: 0.6rem;
}

.logoImg {
  width: 100%;
  height: auto;
}

.navBox {
  display: flex;
  padding: 0 0.16rem;
}

.navItem {
  font-size: 0.16rem;
  min-width: 0.8rem;
  height: 0.65rem;
  line-height: 0.65rem;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/naviHeader.vue